/* This function returns a Promise. After this Promise is resolved every prior made DOM changes took effect.
 * This can be helpful when reading values from DOM elements */
export const nextTick = () => {
  return new Promise(res => {
    setTimeout(() => {
      res();
    }, 1);
  });
};